let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("axtR8")).then(() => parcelRequire('jEXQK'));